import React, { FC, PropsWithChildren } from 'react'
import Loader from './Loader'

interface PageContainerProps extends PropsWithChildren {
    loading?: boolean
}

const PageContainer: FC<PageContainerProps> = ({ loading, children }) => {
    if (loading) {
        return <Loader />
    }
    return children
}

export default PageContainer
